var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "stayCard" },
    [
      _vm.isAlertsDrawerVisible
        ? _c(
            "v-navigation-drawer",
            {
              attrs: { absolute: "", temporary: "", right: true },
              model: {
                value: _vm.isAlertsDrawerVisible,
                callback: function($$v) {
                  _vm.isAlertsDrawerVisible = $$v
                },
                expression: "isAlertsDrawerVisible"
              }
            },
            [
              _c(
                "v-layout",
                [
                  _c("v-flex", [
                    _c(
                      "div",
                      { staticClass: "ntstSectionTitle legendSectionHeader" },
                      [_vm._v("Alerts")]
                    )
                  ])
                ],
                1
              ),
              _c("v-divider", { staticClass: "legendDivider" }),
              _vm._l(_vm.getAlertCodes(), function(code, index) {
                return _c(
                  "v-flex",
                  {
                    key: "asc-" + index,
                    style: _vm.getAlertStyle(code),
                    on: {
                      click: function($event) {
                        _vm.toggleAlert(code)
                      }
                    }
                  },
                  [
                    _c("alert-visualized-coded-entry", {
                      staticClass: "alert legendItemIcon",
                      attrs: { "visualized-coded-entry": code }
                    }),
                    _c("span", { staticClass: "legendItemText" }, [
                      _vm._v(_vm._s(code.displayName))
                    ])
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e(),
      _c(
        "v-card-title",
        [
          _c("v-layout", { attrs: { row: "" } }, [
            _c(
              "span",
              { staticClass: "clientStatusAndImage" },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c("span", { style: _vm.dischargeStatusBarStyle }),
                    _c(
                      "v-avatar",
                      { staticClass: "clientAvatar", attrs: { size: "64px" } },
                      [
                        _c("client-image", {
                          attrs: {
                            clientID: _vm.stay.clientSummary.clientID.id,
                            clientName: _vm.stay.clientSummary.clientName
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("span", [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "clientContainer" },
                  [
                    _c("span", { staticClass: "clientText" }, [
                      _vm._v(_vm._s(_vm.clientText))
                    ]),
                    _vm._l(_vm.alerts, function(code, index) {
                      return _vm.alerts
                        ? _c(
                            "span",
                            { key: index },
                            [
                              _c("alert-visualized-coded-entry", {
                                staticClass: "alert",
                                attrs: {
                                  "visualized-coded-entry": code,
                                  alertDisplayName: _vm.getAlertDisplayName(
                                    code
                                  )
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    })
                  ],
                  2
                ),
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Attending Physician")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.attendingPhysicianName))
                ])
              ])
            ])
          ]),
          _c("v-spacer"),
          _vm.isEditable && _vm.isActionable
            ? _c(
                "v-btn",
                {
                  staticClass: "ntstAppButton",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.toogleAlertsDrawer()
                    }
                  }
                },
                [_vm._v("Toggle Alerts")]
              )
            : _vm._e(),
          _vm.isCloseVisible
            ? _c(
                "v-btn",
                {
                  attrs: { xs: "", icon: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.cancel()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        { style: _vm.cardTextStyle },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _vm.isActionable
                ? _c(
                    "v-flex",
                    [
                      _c("div", { staticClass: "ntstValueLabel" }, [
                        _vm._v("Discharge Status")
                      ]),
                      _vm.isEditable && _vm.isActionable
                        ? _c("v-select", {
                            staticClass: "staySelector",
                            attrs: {
                              disabled: !(_vm.isEditable && _vm.isActionable),
                              items: _vm.dischargeStatusCodes,
                              outline: "",
                              "item-value": "code",
                              "item-text": "displayName"
                            },
                            model: {
                              value: _vm.dischargeStatusCodeValue,
                              callback: function($$v) {
                                _vm.dischargeStatusCodeValue = $$v
                              },
                              expression: "dischargeStatusCodeValue"
                            }
                          })
                        : _vm._e(),
                      !(_vm.isEditable && _vm.isActionable)
                        ? _c("div", [
                            _vm._v(_vm._s(_vm.dischargeStatusCodeDisplayName))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isActionable
                ? _c("v-flex", [
                    _c("div", { staticClass: "ntstValueLabel" }, [
                      _vm._v("Reservation Status")
                    ]),
                    _c("div", { staticClass: "ntstValue" }, [
                      _vm._v(_vm._s(_vm.reservationStatusCodeDisplayName))
                    ])
                  ])
                : _vm._e(),
              _c("v-flex", [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Room Assignment")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.room.name))
                ])
              ]),
              _vm.availableBeds
                ? _c(
                    "v-flex",
                    [
                      _c("div", { staticClass: "ntstValueLabel" }, [
                        _vm._v("Bed Assignment")
                      ]),
                      _vm.isEditable && _vm.isActionable
                        ? _c("v-select", {
                            staticClass: "staySelector",
                            attrs: {
                              disabled: !(_vm.isEditable && _vm.isActionable),
                              items: _vm.availableBeds,
                              "item-value": "bedBoardBedID.id",
                              outline: "",
                              "item-text": "name"
                            },
                            model: {
                              value: _vm.bedIDValue,
                              callback: function($$v) {
                                _vm.bedIDValue = $$v
                              },
                              expression: "bedIDValue"
                            }
                          })
                        : _vm._e(),
                      !(_vm.isEditable && _vm.isActionable)
                        ? _c("div", [_vm._v(_vm._s(_vm.bedName))])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "ntstSectionTitle",
              staticStyle: { "margin-top": "6px" }
            },
            [_vm._v("Client Details")]
          ),
          _c("v-divider"),
          _c(
            "v-layout",
            { staticClass: "clientDetailsRow", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Emergency Contact")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.emergencyContact))
                ])
              ]),
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Allergies")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.allergies))
                ])
              ])
            ],
            1
          ),
          _c(
            "v-layout",
            { staticClass: "clientDetailsRow", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [_vm._v("Alias")]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.alias))
                ])
              ]),
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [_vm._v("DOB")]),
                _vm.dob
                  ? _c("div", { staticClass: "ntstValue" }, [
                      _vm._v(_vm._s(_vm._f("moment")(_vm.dob, "MM/DD/YYYY")))
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _c(
            "v-layout",
            { staticClass: "clientDetailsRow", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Primary Dx")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.primaryDx))
                ])
              ]),
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Admission Date")
                ]),
                _vm.admissionDate
                  ? _c("div", { staticClass: "ntstValue" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("moment")(_vm.admissionDate, "MM/DD/YYYY")
                        )
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _c(
            "v-layout",
            { staticClass: "clientDetailsRow", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Treatment Team")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.treatmentTeam))
                ])
              ]),
              _vm.isActionable
                ? _c("v-flex", { attrs: { xs6: "" } }, [
                    _c("div", { staticClass: "ntstValueLabel" }, [
                      _vm._v("Race")
                    ]),
                    _c("div", { staticClass: "ntstValue" }, [
                      _vm._v(_vm._s(_vm.races))
                    ])
                  ])
                : _vm._e(),
              !_vm.isActionable
                ? _c("v-flex", [
                    _c("div", { staticClass: "ntstValueLabel" }, [
                      _vm._v("Reservation Information")
                    ]),
                    _c("div", { staticClass: "ntstValue" }, [
                      _vm._v(_vm._s(_vm.stay.reservationDescription))
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-layout",
            { staticClass: "clientDetailsRow", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v(_vm._s(_vm.guarantorLabel))
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.guarantorDescription))
                ])
              ]),
              !_vm.isActionable
                ? _c("v-flex", { attrs: { xs6: "" } }, [
                    _c("div", { staticClass: "ntstValueLabel" }, [
                      _vm._v("Race")
                    ]),
                    _c("div", { staticClass: "ntstValue" }, [
                      _vm._v(_vm._s(_vm.races))
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm.unit.isGuardianVisible
            ? _c(
                "v-layout",
                { staticClass: "clientDetailsRow", attrs: { row: "" } },
                [
                  _c("v-flex", { attrs: { xs6: "" } }, [
                    _c("div", { staticClass: "ntstValueLabel" }, [
                      _vm._v(_vm._s(_vm.guardianLabel))
                    ]),
                    _c("div", { staticClass: "ntstValue" }, [
                      _vm._v(_vm._s(_vm.guardianDescription))
                    ])
                  ])
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "ntstSectionTitle" }, [
            _vm._v("Next Med Admin Time")
          ]),
          _c("v-divider"),
          _c(
            "v-layout",
            { staticClass: "clientDetailsRow", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v(_vm._s(_vm.nextMedAdminTime))
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.nextMedAdminMedication))
                ])
              ])
            ],
            1
          ),
          _c("div", { staticClass: "ntstSectionTitle" }, [
            _vm._v("Staff Notes")
          ]),
          _c("v-divider"),
          _c("v-textarea", {
            attrs: {
              outline: "",
              name: "input-7-4",
              readonly: !_vm.isStaffNotesEditable || !_vm.isActionable
            },
            model: {
              value: _vm.stay.staffNotes,
              callback: function($$v) {
                _vm.$set(_vm.stay, "staffNotes", $$v)
              },
              expression: "stay.staffNotes"
            }
          })
        ],
        1
      ),
      _c("v-divider"),
      _vm.isActionable && (_vm.isEditable || _vm.isStaffNotesEditable)
        ? _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ntstAppButton",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.cancel()
                    }
                  }
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ntstAppButton",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.save()
                    }
                  }
                },
                [_vm._v("\n      Save\n    ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }